export enum MenuEntries {
  Home = 'home',
  About = 'about',
  Profession = 'the-profession',
  News = 'news',
  Pricing = 'pricing',
  Contact = 'contact',
  Search = 'search',
}
